import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../config';

@Injectable()
export class LoginService {

  headers = new Headers();

  constructor(private _http: Http) { }

  login(user: any){
    this.headers = new Headers({ 'Authorization': 'Basic ' + btoa(user.email + ":" + user.password) });
    return this._http.post(AppConfig.apiAdresaMongoVimeo + 'auth/', user, {headers: this.headers})    
    .map(res => res.json()); 
  }

  loginSql(user: any){
    // this.headers = new Headers({ 'Authorization': 'Basic ' + btoa(user.email + ":" + user.password) });
    return this._http.post(AppConfig.apiAdresaSQL + 'prijavaweb', user) /* {headers: this.headers} */    
    .map(res => res.json()); 
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/login/login.service.ts